import { createFetcher } from "api/helpers"

const fetcherConfiguration = {
  method: "post",
  makeRequestUrl: (host, project, ticket_id) => {
    return `${host}/itsm/service_feedback/${project}/${ticket_id}`
  },
  checkRequiredArguments: (feedbackData) => {
    if (feedbackData === undefined) throw new Error("No feedback data supplied.")
  },
  makeResponseData: (json) => {
    return json
  }
}
export default createFetcher(fetcherConfiguration)
